<script setup>
import Button from 'primevue/button';
import { onMounted, ref } from 'vue';
import { supabase } from '@/supabase';





const loading = ref(false);

async function assinar() {
    loading.value = true;
     const { data, error } = await supabase.functions.invoke(
         'createStripeSession',
         {
             body: { priceId: "price_1SwoHLPkAWGaS3UrIAj4el9B" }
         }
     );

    if (error) {
        console.error(error);
        throw error;
    }

    window.location.href = data.url;
}


</script>
<template>
   <div class="surface-50">
       <div class="container ">
            <div class="conteudo">
                <header class="cabecalho">
                    <h1>Assinatura</h1>
                    <p>
                        Para continuar usando recursos para professores,
                        crie uma assinatura usando o botão abaixo.
                    </p>

                    <Button label="Assinar por R$ 20,00 / mês" :loading="loading" @click="assinar" />
                </header>

                <section class="secao">
                    <h2>Quanto tempo demora para eu poder usar o site depois de concluir a assinatura?</h2>
                    <p>A liberação é instantânea. Assim que o pagamento for confirmado, os recursos de assinate são liberados.</p>

                </section>

                <section class="secao">
                    <h2>É seguro fazer a assinatura no Minha Escola?</h2>

                    <p>Sim, é totalmente seguro.</p>

                    <p>
                        O Minha Escola não tem acesso a nenhuma informação de pagamento dos usuários.
                        Dados como número do cartão de crédito, código de segurança ou senha
                        nunca passam pelo nosso site.
                    </p>

                    <p>
                        Todo o pagamento é processado pelo Stripe, que é um sistema de pagamento
                        internacional especializado e utilizado por milhares de empresas no mundo todo.
                        O papel do Stripe é cuidar de toda a parte sensível do pagamento com segurança.
                    </p>

                    <p>
                        Na prática, funciona assim:
                        o Stripe processa o pagamento e apenas informa ao Minha Escola que a
                        assinatura foi confirmada. Com isso, o sistema libera automaticamente
                        o acesso aos recursos para o usuário. O site nunca vê nem armazena
                        dados financeiros.
                    </p>
                </section>

                <section class="secao">
                    <h2>Como funciona a assinatura?</h2>

                    <p>
                        A assinatura do Minha Escola é mensal, no valor de R$ 20,00.
                    </p>

                    <p>
                        Ao assinar, você tem acesso imediato aos recursos disponíveis para assinantes.
                        A renovação acontece de forma automática todo mês, para que você não precise
                        refazer o processo manualmente.
                    </p>

                    <p>
                        Não existe fidelidade nem multa:
                        você pode cancelar quando quiser, diretamente pelo site.
                    </p>

                    <p>
                        Para evitar qualquer cobrança indesejada, todo mês você recebe um e-mail
                        avisando que a assinatura será renovada. Se não quiser continuar,
                        é só acessar o Minha Escola, entrar no menu do usuário,
                        gerenciar a assinatura e cancelar antes da renovação.
                    </p>
                </section>

                <section class="secao">
                    <h2>Posso cancelar a assinatura a qualquer momento?</h2>

                    <p>Sim.</p>

                    <p>
                        O cancelamento é simples e pode ser feito a qualquer momento pelo próprio
                        painel do usuário no Minha Escola.
                    </p>

                    <p>
                        Após o cancelamento, você não terá novas cobranças, e o acesso permanece
                        ativo até o fim do período já pago.
                    </p>
                </section>

                <section class="secao">
                    <h2>Como funciona o pagamento por boleto?</h2>

                    <p>
                        Também é possível pagar a assinatura por boleto bancário.
                    </p>

                    <p>
                        Nesse caso, o processo funciona assim:
                        você gera o boleto, realiza o pagamento e aguarda a compensação.
                        Em dias úteis, o boleto costuma ser processado no mesmo dia ou,
                        no máximo, no dia útil seguinte. Assim que o pagamento é confirmado,
                        o acesso é liberado automaticamente.
                    </p>

                    <p>
                        Na renovação mensal por boleto, você recebe por e-mail um aviso junto
                        com um novo boleto para pagamento. Para continuar usando o serviço,
                        basta efetuar o pagamento do boleto enviado. Caso não pague,
                        a assinatura não é renovada.
                    </p>
                </section>
            </div>
        </div>
   </div>
</template>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    padding: 50px 16px;
}

.conteudo {
    max-width: 760px;
    width: 100%;
}

.cabecalho {
    text-align: center;
    margin-bottom: 70px;
}

.cabecalho h1 {
    font-size: 2rem;
    margin-bottom: 10px;
}

.cabecalho p {
    color: #555;
    margin-bottom: 24px;
}

.secao {
    margin-bottom: 40px;
}

.secao h2 {
    font-size: 1.35rem;
    margin-bottom: 16px;
}

.secao p {
    line-height: 1.7;
    color: #444;
    margin-bottom: 12px;
}
</style>